import React from 'react';
import { Toast as RBToast, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
export default function Toast(_ref) {
  let {
    message,
    variant = 'success',
    show,
    onClose,
    reportable,
    accountType
  } = _ref;
  const textColor = variant === 'light' ? 'secondary' : 'white';
  const history = useHistory();
  const handleReportClick = () => {
    onClose();
    history.push(`/${accountType}/report_issues`);
  };
  const wrapperStyle = reportable ? {
    position: 'fixed',
    top: '10%',
    right: '16px',
    transform: 'translateY(-50%)',
    zIndex: 9999,
    width: '350px'
  } : {
    position: 'fixed',
    top: 0,
    right: 0,
    zIndex: 9999,
    width: '100%'
  };
  return /*#__PURE__*/React.createElement("div", {
    style: wrapperStyle
  }, /*#__PURE__*/React.createElement(RBToast, {
    className: `bg-${variant} text-${textColor}`,
    show: show,
    onClose: onClose,
    delay: reportable ? 5000 : 2000,
    autohide: true,
    style: reportable ? {
      width: '350px'
    } : undefined
  }, /*#__PURE__*/React.createElement(RBToast.Body, {
    className: "position-relative"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    "aria-label": "Close",
    style: {
      position: 'absolute',
      top: '6px',
      right: '8px',
      background: 'transparent',
      border: 'none',
      color: 'rgba(255,255,255,0.8)',
      fontSize: '1.1rem',
      lineHeight: 1,
      cursor: 'pointer',
      padding: 0
    }
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center flex-wrap gap-2 pe-3"
  }, /*#__PURE__*/React.createElement("span", null, message), reportable && /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    variant: "outline-light",
    onClick: handleReportClick
  }, "Submit issue")))));
}